import React from 'react';

import { useSnackbar } from 'notistack';

import { Download } from '@mui/icons-material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { Box, Button, IconButton } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import { useDownloadFlightTraces } from '~/hooks/apis/flights/useDownloadFlightTraces';

import { useFlightsLogViewer } from './FlightsLogsViewerProvider';

interface Props {
  reservationId: string;
}

export function FlightsLogsViewerHeader({ reservationId }: Props) {
  const { theme, setTheme } = useFlightsLogViewer();
  const { enqueueSnackbar } = useSnackbar();
  const downloadFlightTraces = useDownloadFlightTraces();

  const handleDownload = () => {
    downloadFlightTraces.mutate(reservationId, {
      onError: (error) => {
        enqueueSnackbar(error instanceof Error ? error.message : 'Failed to download flight logs', {
          variant: 'error',
        });
      },
    });
  };

  return (
    <PageHeader title="Flights Logs Viewer">
      <Box display="flex" alignItems="center" gap={3}>
        <Button
          variant="contained"
          onClick={handleDownload}
          disabled={downloadFlightTraces.isPending}
          startIcon={<Download />}
        >
          {downloadFlightTraces.isPending ? 'Downloading...' : 'Download Files'}
        </Button>

        {theme === 'dark' && (
          <IconButton onClick={() => setTheme('light')}>
            <LightModeIcon color="primary" />
          </IconButton>
        )}

        {theme === 'light' && (
          <IconButton onClick={() => setTheme('dark')}>
            <DarkModeIcon color="primary" />
          </IconButton>
        )}
      </Box>
    </PageHeader>
  );
}
